// import React, { useState } from "react";
// import { Pie } from "react-chartjs-2";
// import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

// ChartJS.register(ArcElement, Tooltip, Legend);

// const LoanCalculator = () => {
//   const [loanAmount, setLoanAmount] = useState(5000);
//   const [loanDays, setLoanDays] = useState(5);
//   const [interestRate, setInterestRate] = useState(2.75);

//   const interest = (loanAmount * (interestRate / 100) * loanDays).toFixed(2);
//   const totalAmount = (parseFloat(loanAmount) + parseFloat(interest)).toFixed(
//     2
//   );

//   const pieChartData = {
//     labels: ["Principal", "Interest"],
//     datasets: [
//       {
//         data: [loanAmount, interest],
//         backgroundColor: ["#4FA0FF", "#FFD700"],
//         borderWidth: 0,
//       },
//     ],
//   };

//   const features = [
//     {
//       icon: "📅",
//       title: "Flexible Tenure",
//       description: "Choose repayment terms that align with your salary cycle.",
//     },
//     {
//       icon: "⏰",
//       title: "24x7 Access",
//       description: "Apply for a loan anytime, anywhere — even on weekends.",
//     },
//     {
//       icon: "👁️",
//       title: "Live Loan Tracking",
//       description: "Track your loan status in real-time with full transparency.",
//     },
//     {
//       icon: "🧮",
//       title: "Smart Calculator",
//       description: "Know exactly what you'll pay upfront",
//     },
//     {
//       icon: "🔒",
//       title: "Bank-Level Security",
//       description: "All your information is encrypted and safely stored.",
//     },
//     {
//       icon: "💳",
//       title: "No Hidden Fees",
//       description: "Transparent pricing with no hidden fees or surprise costs.",
//     },
//   ];

//   return (
//     <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
//       <div className="max-w-6xl mx-auto">
//         {/* Header */}
//         <div className="text-center mb-12">
//           <h1 className="text-3xl font-bold text-gray-900 sm:text-4xl">
//             Personal Loan Calculator
//           </h1>
//           <p className="mt-3 text-xl text-gray-500">
//             Calculate your loan payments with ease
//           </p>
//         </div>

//         <div className="bg-white rounded-2xl shadow-sm p-6 mb-12">
//           <div className="flex flex-col lg:flex-row gap-8">
//             <div className="flex-1 space-y-8">
//               <div>
//                 <div className="flex justify-between items-center mb-2">
//                   <h2 className="block text-md font-medium text-gray-800">
//                     Loan Amount
//                   </h2>

//                   <h3 className="text-black text-sm">
//                     Limits:
//                     <span className="text-sm text-gray-500 ml-2">
//                       ₹5,000 - ₹100,000
//                     </span>
//                   </h3>
//                 </div>
//                 <input
//                   type="range"
//                   min={5000}
//                   max={100000}
//                   step={500}
//                   value={loanAmount}
//                   onChange={(e) => setLoanAmount(Number(e.target.value))}
//                   className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-[#4FA0FF] "
//                 />
//                 <div className="mt-2 text-2xl font-semibold text-gray-900">
//                   ₹{loanAmount.toLocaleString()}
//                 </div>
//               </div>

//               <div>
//                 <div className="flex justify-between items-center mb-2">
//                   <h2 className="block text-md font-medium text-gray-800">
//                     Loan Tenure (Days)
//                   </h2>
//                   <h3 className="text-black text-sm">
//                     Limits:
//                     <span className="text-sm text-gray-500 ml-2">
//                       1 - 90 Days
//                     </span>
//                   </h3>
//                 </div>
//                 <input
//                   type="range"
//                   min={1}
//                   max={90}
//                   value={loanDays}
//                   onChange={(e) => setLoanDays(Number(e.target.value))}
//                   className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-[#4FA0FF]"
//                 />
//                 <div className="mt-2 text-2xl font-semibold text-gray-900">
//                   {loanDays} Days
//                 </div>
//               </div>

//               {/* Interest Rate */}
//               <div>
//                 <div className="flex justify-between items-center mb-2">
//                   <h2 className="block text-md font-medium text-gray-800">
//                     Daily Interest Rate
//                   </h2>

//                   <h3 className="text-black text-sm">
//                     Limits:
//                     <span className="text-sm text-gray-500 ml-2">
//                       0.5% - 2.75%
//                     </span>
//                   </h3>
//                 </div>
//                 <input
//                   type="range"
//                   min={0.5}
//                   max={2.75}
//                   step={0.01}
//                   value={interestRate}
//                   onChange={(e) => setInterestRate(Number(e.target.value))}
//                   className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-[#4FA0FF]"
//                 />
//                 <div className="mt-2 text-2xl font-semibold text-gray-900">
//                   {interestRate}%
//                 </div>
//               </div>
//             </div>

//             {/* Pie Chart */}
//             <div className="flex-1 flex items-center justify-center">
//               <div className="w-full max-w-xs">
//                 <Pie
//                   data={pieChartData}
//                   options={{
//                     plugins: {
//                       legend: {
//                         position: "bottom",
//                         labels: {
//                           color: "#6B7280",
//                           font: {
//                             size: 14,
//                           },
//                         },
//                       },
//                     },
//                   }}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Results Summary */}
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-12">
//           <div className="flex flex-col items-center justify-center gap-3 bg-white p-6 rounded-xl shadow-sm border border-gray-100">
//             <span className="text-black text-3xl">₹</span>
//             <div className="text-gray-500 mb-1">Loan Amount</div>
//             <div className="text-2xl font-bold text-[#1D3557]">
//               ₹{loanAmount.toLocaleString()}
//             </div>
//           </div>
//           <div className="flex flex-col items-center justify-center gap-3 bg-white p-6 rounded-xl shadow-sm border border-gray-100">
//             <span className="text-black text-3xl">📈</span>
//             <div className="text-gray-500 mb-1">Total Interest</div>
//             <div className="text-2xl font-bold text-[#1D3557]">
//               ₹{Number(interest).toLocaleString()}
//             </div>
//           </div>
//           <div className="flex flex-col items-center justify-center gap-3 bg-white p-6 rounded-xl shadow-sm border border-gray-100">
//             <span className="text-black text-3xl">🔢</span>
//             <div className="text-gray-500 mb-1">Total Payable</div>
//             <div className="text-2xl font-bold text-[#1D3557]">
//               ₹{Number(totalAmount).toLocaleString()}
//             </div>
//           </div>
//           <div className="flex flex-col items-center justify-center gap-3 bg-white p-6 rounded-xl shadow-sm border border-gray-100">
//             <span className="text-black text-3xl">📅</span>
//             <div className="text-gray-500 mb-1">Loan Duration</div>
//             <div className="text-2xl font-bold text-[#1D3557]">
//               {loanDays} Days
//             </div>
//           </div>
//         </div>

//         <div className="pt-20">
//           <div className="text-center mb-12">
//             <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl">
//               Why Choose Our Loan Service
//             </h2>
//             <p className="mt-3 text-xl text-gray-500">
//               We make borrowing simple, transparent, and tailored to your needs
//             </p>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//             {features.map((feature, index) => (
//               <div
//                 key={index}
//                 className="flex flex-col items-center justify-center gap-4 text-center bg-white p-6 rounded-xl shadow-sm hover:shadow-md transition-shadow border border-gray-100"
//               >
//                 <div className="text-3xl  text-[#4FA0FF]">{feature.icon}</div>
//                 <h3 className="text-xl font-semibold text-gray-900">
//                   {feature.title}
//                 </h3>
//                 <p className="text-sm text-gray-600">{feature.description}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LoanCalculator;
// import React, { useState } from "react";
// import { Pie } from "react-chartjs-2";
// import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
// import loanBg from "../../images/features_img.png"; // background image
// import bgImage from "../../images/personalloan.jpg"; // background image

// ChartJS.register(ArcElement, Tooltip, Legend);

// const LoanCalculator = () => {
//   const [loanAmount, setLoanAmount] = useState(5000);
//   const [loanDays, setLoanDays] = useState(5);
//   const [interestRate, setInterestRate] = useState(2.75);

//   const interest = (loanAmount * (interestRate / 100) * loanDays).toFixed(2);
//   const totalAmount = (parseFloat(loanAmount) + parseFloat(interest)).toFixed(
//     2
//   );

//   const pieChartData = {
//     labels: ["Principal", "Interest"],
//     datasets: [
//       {
//         data: [loanAmount, interest],
//         backgroundColor: ["#4FA0FF", "#FFD700"],
//         borderWidth: 0,
//       },
//     ],
//   };

//   const features = [
//     {
//       icon: "📅",
//       title: "Flexible Tenure",
//       description: "Choose repayment terms that align with your salary cycle.",
//     },
//     {
//       icon: "⏰",
//       title: "24x7 Access",
//       description: "Apply for a loan anytime, anywhere — even on weekends.",
//     },
//     {
//       icon: "👁️",
//       title: "Live Loan Tracking",
//       description:
//         "Track your loan status in real-time with full transparency.",
//     },
//     {
//       icon: "🔒",
//       title: "Bank-Level Security",
//       description: "All your information is encrypted and safely stored.",
//     },
//   ];

//   return (
//     <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
//       <div className="max-w-6xl mx-auto">
//         {/* Header */}
//         <div className="text-center mb-12">
//           <h1 className="text-3xl sm:text-4xl font-bold">
//             <span className="text-[#1D3557]">Personal Loan</span>{" "}
//             <span className="text-[#2563EB]">Calculator</span>
//           </h1>

//           <p className="mt-3 text-xl text-gray-500">
//             Calculate your loan payments with ease
//           </p>
//         </div>
//         <div className="relative rounded-3xl overflow-hidden mb-12">
//           {/* Background Image ONLY behind sliders */}
//           <div
//             className="absolute inset-0 z-0"
//             style={{
//               background: "linear-gradient(to right, #E3E8F0, #D6E4FF)",
//               // opacity agar chahiye to add kardo, e.g., opacity: 0.6
//             }}
//           ></div>

//           <div className="flex flex-col lg:flex-row gap-8 relative z-10 p-6">
//             {/* Sliders */}
//             <div className="flex-1 space-y-6">
//               <div>
//                 <h2 className="text-gray-800 font-medium mb-1">Loan Amount</h2>
//                 <input
//                   type="range"
//                   min={5000}
//                   max={100000}
//                   step={500}
//                   value={loanAmount}
//                   onChange={(e) => setLoanAmount(Number(e.target.value))}
//                   className="w-full h-2 bg-gray-200 rounded-lg accent-[#4FA0FF]"
//                 />
//                 <div className="mt-2 text-2xl font-semibold text-gray-900">
//                   ₹{loanAmount.toLocaleString()}
//                 </div>
//               </div>

//               <div>
//                 <h2 className="text-gray-800 font-medium mb-1">
//                   Loan Tenure (Days)
//                 </h2>
//                 <input
//                   type="range"
//                   min={1}
//                   max={90}
//                   value={loanDays}
//                   onChange={(e) => setLoanDays(Number(e.target.value))}
//                   className="w-full h-2 bg-gray-200 rounded-lg accent-[#4FA0FF]"
//                 />
//                 <div className="mt-2 text-2xl font-semibold text-gray-900">
//                   {loanDays} Days
//                 </div>
//               </div>

//               <div>
//                 <h2 className="text-gray-800 font-medium mb-1">
//                   Daily Interest Rate
//                 </h2>
//                 <input
//                   type="range"
//                   min={0.5}
//                   max={2.75}
//                   step={0.01}
//                   value={interestRate}
//                   onChange={(e) => setInterestRate(Number(e.target.value))}
//                   className="w-full h-2 bg-gray-200 rounded-lg accent-[#FFD700]"
//                 />
//                 <div className="mt-2 text-2xl font-semibold text-gray-900">
//                   {interestRate}%
//                 </div>
//               </div>
//             </div>

//             {/* Pie Chart without any background */}
//             <div className="flex-1 flex items-center justify-center relative">
//               <div className="w-full max-w-xs bg-white rounded-2xl p-4 shadow-lg">
//                 <Pie
//                   data={pieChartData}
//                   options={{
//                     plugins: {
//                       legend: {
//                         position: "bottom",
//                         labels: { color: "#374151", font: { size: 14 } },
//                       },
//                     },
//                   }}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Result Summary Cards */}
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
//           {[
//             {
//               icon: "₹",
//               label: "Loan Amount",
//               value: `₹${loanAmount.toLocaleString()}`,
//             },
//             {
//               icon: "📈",
//               label: "Total Interest",
//               value: `₹${Number(interest).toLocaleString()}`,
//             },
//             {
//               icon: "🔢",
//               label: "Total Payable",
//               value: `₹${Number(totalAmount).toLocaleString()}`,
//             },
//             { icon: "📅", label: "Loan Duration", value: `${loanDays} Days` },
//           ].map((item, idx) => (
//             <div
//               key={idx}
//               className="flex flex-col items-center justify-center gap-3 p-6 rounded-2xl
//              bg-gradient-to-br from-[#2563EB]/10 to-[#E5E7EB]/20
//              border border-[#2563EB]/20 shadow-lg hover:shadow-2xl
//              transform hover:-translate-y-2 transition-all duration-300"
//             >
//               <span className="text-4xl">{item.icon}</span>
//               <div className="text-gray-500 font-medium">{item.label}</div>
//               <div className="text-2xl font-bold text-[#1D3557]">
//                 {item.value}
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* Why Choose Us Cards */}

//         <div className="pt-10 max-w-6xl mx-auto  rounded -2xl">
//           <section className="relative py-20 overflow-hidden">
//             {/* Overlay */}
//             <div className="absolute inset-0  rounded-2xl bg-gradient-to-br from-[#2563EB]/10 to-[#E5E7EB]/20 "></div>

//             <div className="relative z-10 max-w-7xl mx-auto">
//               <div className="text-center mb-12">
//                 <h2 className="text-3xl sm:text-4xl font-bold">
//                   <span className="text-[#1D3557]">Why Choose</span>{" "}
//                   <span className="text-[#2563EB] ">Our Loan Service</span>
//                 </h2>

//                 <p className="mt-3 text-xl text-[#4A5568]">
//                   We make borrowing simple, transparent, and tailored to your
//                   needs
//                 </p>
//               </div>

//               <div className="flex flex-col lg:flex-row items-center justify-between relative flex-wrap">
//                 {/* Left Content */}
//                 <div className="flex-1 px-4 lg:pr-8 lg:pl-8 mb-8 lg:mb-0">
//                   <div className="flex flex-col items-start space-y-4">
//                     {features.map((feature, index) => (
//                       <div
//                         key={index}
//                         className="flex items-start gap-4 bg-white p-6 rounded-xl shadow-sm hover:shadow-md transition-shadow border border-gray-100 w-full max-w-md"
//                       >
//                         <div className="text-3xl text-[#4FA0FF]">
//                           {feature.icon}
//                         </div>
//                         <div>
//                           <h3 className="text-xl font-semibold text-[#1D3557]">
//                             {feature.title}
//                           </h3>
//                           <p className="text-sm text-gray-600">
//                             {feature.description}
//                           </p>
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 </div>

//                 {/* Right Image */}
//                 <div className="flex-shrink-0 w-full lg:w-1/2 px-4 lg:pl-8">
//                   <img
//                     src={bgImage}
//                     alt="Decorative"
//                     className="w-full h-full object-cover rounded-3xl"
//                   />
//                 </div>
//               </div>
//             </div>
//           </section>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LoanCalculator;
import React, { useState } from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";
import bgImage from "../../images/contact_form_img.png"; // <-- your folder image

function Calculator() {
  const [supportAmount, setSupportAmount] = useState(5000);
  const [supportDays, setSupportDays] = useState(5);
  const [serviceRate, setServiceRate] = useState(2.75);

  const serviceFee = supportAmount * (serviceRate / 100) * supportDays;
  const totalAmount = supportAmount + serviceFee;

  const pieData = [
    { name: "Support Amount", value: supportAmount },
    { name: "Service Fee", value: serviceFee },
  ];

  const COLORS = ["#4F8BFF", "#9BB8FF"];

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0A0F1F] to-[#1A2238] pb-20 px-6">
      {/* HEADING SECTION */}
      <div className="text-center pt-10 mb-10">
        <h1 className="text-4xl font-extrabold text-center">
          <span className="text-gray-300">Financial </span>
          <span className="text-[#3B82F6]">Support Calculator</span>
        </h1>

        <p className="text-gray-300 text-lg mt-2">
          Calculate your support amount, service fee, and total payable in seconds
        </p>
      </div>

      {/* CALCULATOR CARD */}
      <div className="w-full max-w-6xl mx-auto bg-white/10 backdrop-blur-lg p-10 rounded-3xl shadow-2xl border border-white/10">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          {/* LEFT INPUT SECTION */}
          <div className="space-y-10">
            {/* Support Amount Slider */}
            <div>
              <label className="text-lg font-semibold text-white">
                Support Amount: ₹{supportAmount.toLocaleString()}
              </label>
              <input
                type="range"
                min="5000"
                max="100000"
                step="500"
                value={supportAmount}
                onChange={(e) => setSupportAmount(Number(e.target.value))}
                className="w-full accent-[#4F8BFF]"
              />
            </div>

            {/* Support Days */}
            <div>
              <label className="text-lg font-semibold text-white">
                Support Duration: {supportDays} Days
              </label>
              <input
                type="range"
                min="1"
                max="90"
                value={supportDays}
                onChange={(e) => setSupportDays(Number(e.target.value))}
                className="w-full accent-[#4F8BFF]"
              />
            </div>

            {/* Service Rate */}
            <div>
              <label className="text-lg font-semibold text-white">
                Daily Service Rate: {serviceRate.toFixed(2)}%
              </label>
              <input
                type="range"
                min="0.5"
                max="2.75"
                step="0.01"
                value={serviceRate}
                onChange={(e) => setServiceRate(Number(e.target.value))}
                className="w-full accent-[yellow]"
              />
            </div>

            {/* FOUR RESULT CARDS */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {[
                {
                  label: "Support Amount",
                  value: `₹${supportAmount.toLocaleString()}`,
                },
                {
                  label: "Total Service Fee",
                  value: `₹${Math.round(serviceFee).toLocaleString()}`,
                },
                {
                  label: "Total Payable",
                  value: `₹${Math.round(totalAmount).toLocaleString()}`,
                },
                { label: "Support Duration", value: `${supportDays} Days` },
              ].map((item, idx) => (
                <div
                  key={idx}
                  className="p-6 rounded-2xl bg-white/10 shadow-lg 
                  border border-white/20 hover:shadow-xl hover:-translate-y-1 
                  transition-all duration-300"
                >
                  <p className="text-gray-300 text-sm font-medium">
                    {item.label}
                  </p>
                  <p className="text-xl font-bold text-white mt-1">
                    {item.value}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* RIGHT - PIE CHART + TOTAL PAYABLE */}
          <div className="flex flex-col items-center justify-center gap-8">
            {/* PIE CHART */}
            <div
              className="bg-white/10 p-6 rounded-3xl shadow-xl w-full h-[320px] 
              border border-white/10 flex items-center justify-center"
            >
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie
                    data={pieData}
                    dataKey="value"
                    innerRadius={60}
                    outerRadius={100}
                    paddingAngle={5}
                  >
                    {pieData.map((_, i) => (
                      <Cell key={i} fill={COLORS[i]} />
                    ))}
                  </Pie>
                  <Tooltip
                    contentStyle={{
                      background: "white",
                      border: "1px solid #4F8BFF",
                      color: "white",
                    }}
                  />
                </PieChart>
              </ResponsiveContainer>
            </div>

            {/* TOTAL PAYABLE BOX */}
            <div
              className="bg-gradient-to-r from-[#4F8BFF]/20 to-[#9BB8FF]/20 
              p-6 rounded-2xl w-full text-center border border-[#4F8BFF]/30 shadow-md"
            >
              <h3 className="text-lg font-semibold text-white">
                Total Payable
              </h3>
              <p className="text-3xl font-bold text-[#4F8BFF] mt-1">
                ₹{Math.round(totalAmount).toLocaleString()}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* WHY CHOOSE OUR SERVICE */}
      <div
        className="max-w-6xl mx-auto mt-20 bg-cover bg-center bg-no-repeat rounded-3xl p-10"
        style={{
          backgroundImage: `url(${bgImage})`,
        }}
      >
        <h2 className="text-4xl font-extrabold text-center mb-6">
          <span className="text-white">Why Choose Our </span>
          <span
            className="
      bg-clip-text text-transparent
      bg-gradient-to-r from-[#4FA0FF] to-[#1d8df5]
    "
          >
            Financial Support?
          </span>
        </h2>

        <p className="text-center text-gray-200 max-w-2xl mx-auto mb-10">
          We provide instant, transparent, and secure financial solutions that
          fit your needs.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {[
            {
              title: "Instant Approval",
              desc: "Zero paperwork and lightning-fast approval process.",
              icon: "⚡",
            },
            {
              title: "Fully Transparent",
              desc: "No hidden charges — everything is clearly shown.",
              icon: "🔍",
            },
            {
              title: "Secure & Trusted",
              desc: "Bank-grade encryption keeps your data safe.",
              icon: "🔒",
            },
          ].map((box, index) => (
            <div
              key={index}
              className="bg-black/30 backdrop-blur-xl p-8 rounded-3xl shadow-xl 
          border border-white/20 hover:border-white hover:-translate-y-2 
          hover:shadow-2xl transition-all duration-300 text-center"
            >
              <div className="text-5xl mb-4">{box.icon}</div>
              <h3 className="text-xl font-bold text-white mb-2">{box.title}</h3>
              <p className="text-gray-300">{box.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Calculator;